var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1323.75 878.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f7ff;}.cls-2{fill:#ddd6ff;}.cls-3{fill:#c4b8ff;}.cls-4{fill:#40327a;}.cls-13,.cls-23,.cls-5{fill:#fff;}.cls-5{opacity:0.62;}.cls-6,.cls-7{fill:#fdfdff;}.cls-10,.cls-7,.cls-9{fill-rule:evenodd;}.cls-10,.cls-35,.cls-40,.cls-8,.cls-9{fill:#62208b;}.cls-10{opacity:0.27;}.cls-11{opacity:0.41;}.cls-12{fill:#4fddc6;}.cls-13{stroke:#fce7d7;stroke-miterlimit:10;stroke-width:5.92px;}.cls-14,.cls-33{fill:#c86b75;}.cls-15{fill:#e8e1f1;}.cls-16{fill:none;}.cls-17{fill:#301558;}.cls-18{fill:#fefefe;}.cls-19{fill:#621f8b;}.cls-20{fill:#eae3f5;}.cls-21{fill:#f76f4b;}.cls-22{fill:#fed750;}.cls-24{fill:#d4aeae;}.cls-25{fill:#8e443d;}.cls-26{fill:#9b78be;}.cls-27{fill:#37175f;}.cls-28{fill:#253c83;}.cls-29{fill:#caa3d4;}.cls-30{opacity:0.67;}.cls-31{opacity:0.3;}.cls-32{opacity:0.6;}.cls-33{opacity:0.36;}.cls-34{opacity:0.54;}.cls-35{opacity:0.57;}.cls-36{opacity:0.33;}.cls-37{opacity:0.44;}.cls-38{fill:#fdeed5;}.cls-39{fill:#fce7c1;}.cls-40{opacity:0.52;}.cls-41{fill:#1d3066;}.cls-42{fill:#461a66;}.cls-43{fill:#ffc359;}.cls-44{fill:#0c0c0c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "animation"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1243.84,831s135-87.86,54.11-170-105-72-81.76-163.57,117.54-125.64,80.06-195.14c-45-83.42-147.56-7.32-211.31,21.89-118.52,54.31-117.81-26.87-72.3-102.82s48.79-202.58-56.33-202.58c-114.34,0-365.61,247.07-504,417.82C369.43,538.78,309.05,467.67,317.44,402c5.33-41.73,16.42-109.18-9.54-140.21-45.06-53.87-177.43,114.89-224.16,187C-99.18,731,123.17,831,123.17,831Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M574,854.38h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 573.97,
    y: 852.92,
    width: 416.22,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M889.68,876.62h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 889.68,
    y: 875.16,
    width: 181.1,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M502.73,876.62h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 502.73,
    y: 875.16,
    width: 331.25,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.49,876.62h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 253.49,
    y: 875.16,
    width: 49.2,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.24,876.62h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 317.24,
    y: 875.16,
    width: 14.86,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1040.77,854.72h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1040.77,
    y: 853.26,
    width: 84.64,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.37,854.38h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 412.37,
    y: 852.92,
    width: 128.31,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.45,854.38h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 160.45,
    y: 852.92,
    width: 224.37,
    height: 2.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.51,854.38h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 94.51,
    y: 852.92,
    width: 39.2,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 831.01,
    width: 1290.17,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 106.58,
    y: 831.01,
    width: 135.19,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 709.81,
    y: 831.01,
    width: 13.72,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 281.42,
    y: 831.01,
    width: 411.36,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 770.88,
    y: 831.01,
    width: 200.51,
    height: 2.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1159.97,
    y: 831.01,
    width: 28.47,
    height: 2.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.99 367.1 119.65 735.05 354.94 734.89 281.76 367.1 194.99 367.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 365.5,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 372.52,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 379.45,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 386.39,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 393.32,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 400.25,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 407.18,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 268.31,
    y: 414.11,
    width: 3.11,
    height: 6.03,
    rx: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M268.82,418.26a1.57,1.57,0,0,0-1.38,1.05l-3.8,12a.75.75,0,0,0,.72,1.05h11a.74.74,0,0,0,.72-1.05l-3.8-12a1.56,1.56,0,0,0-1.38-1.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 234.61,
    y: 372.83,
    width: 7.66,
    height: 376.51,
    rx: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 227.88,
    y: 340.5,
    width: 21.11,
    height: 41.46,
    rx: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 227.88,
    y: 733.51,
    width: 21.11,
    height: 31.66,
    rx: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M216.92,767.62h43a4.23,4.23,0,0,0,4.22-4.22h0a4.23,4.23,0,0,0-4.22-4.21h-43a4.22,4.22,0,0,0-4.21,4.21h0A4.23,4.23,0,0,0,216.92,767.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M238.43,292.67H218.56a8.27,8.27,0,0,0-7.3,5.54l-20,63.3c-1,3.05.74,5.54,3.79,5.54h86.85c3.05,0,4.75-2.49,3.79-5.54l-20-63.3a8.27,8.27,0,0,0-7.3-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M200,333.81,197.7,341h81.47l-2.29-7.22Zm-3.67,11.59-4.57,14.45h93.37l-4.57-14.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,372.89a.87.87,0,1,1,.87-.87A.87.87,0,0,1,269.86,372.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,379.82a.87.87,0,1,1,.87-.87A.87.87,0,0,1,269.86,379.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,386.76a.88.88,0,1,1,.87-.88A.88.88,0,0,1,269.86,386.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,393.69a.88.88,0,1,1,.87-.88A.88.88,0,0,1,269.86,393.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,400.62a.88.88,0,1,1,.87-.87A.87.87,0,0,1,269.86,400.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,407.55a.88.88,0,1,1,.87-.87A.87.87,0,0,1,269.86,407.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.86,414.48a.87.87,0,1,1,.87-.87A.87.87,0,0,1,269.86,414.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M860.88,326.14c16.47.15,29.49,6.95,37.91,21.16,9.33,15.74,8.72,31.76-.79,47.35a39,39,0,0,1-13.49,13.17,4,4,0,0,0-2,2.51c-1.31,4.62-2.68,9.22-4,13.82-.35,1.19-.66,2.54-2,2.84s-2.18-.84-3-1.81c-2.72-3.34-5.48-6.64-8.21-10a2.59,2.59,0,0,0-2.22-1c-19.42-.16-33.23-9.35-40.77-27a43.9,43.9,0,0,1,32-60.39A28.8,28.8,0,0,1,860.88,326.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M854,323.77c16.47.15,29.49,7,37.91,21.16,9.33,15.75,8.72,31.76-.79,47.36a39.07,39.07,0,0,1-13.49,13.16,4,4,0,0,0-2,2.52c-1.31,4.61-2.68,9.21-4,13.82-.35,1.19-.67,2.53-2.06,2.83s-2.17-.83-3-1.81c-2.72-3.34-5.48-6.64-8.2-10a2.65,2.65,0,0,0-2.22-1c-19.43-.16-33.24-9.34-40.78-27a43.9,43.9,0,0,1,31.95-60.39A29.36,29.36,0,0,1,854,323.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M866.48,368.41c-.13,4.29-.24,8.59-.38,12.88-.08,2.11-.68,2.67-2.83,2.72-1.53,0-3.06,0-4.59,0a97.49,97.49,0,0,0-10.25-.32h0c-1.43-.45-2.91-.17-4.36-.29-1.86-.17-2.58-.87-2.53-2.67.12-4.4.3-8.81.45-13.21a7.9,7.9,0,0,1,1.44-.19c4.39.15,8.79.3,13.18.49C859.9,368,863.22,367.72,866.48,368.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M854.63,334.88c7,.77,11.15,4.19,12.28,10.22a31.81,31.81,0,0,1-.08,8.44c-.86-.08-1.72-.2-2.58-.23l-21.75-.61c0-1.65,0-3.3.08-4.94a13.09,13.09,0,0,1,2.67-8c2.11-2.72,5-4,8.22-4.77h0C853.86,335.23,854.25,335.05,854.63,334.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M842.5,352.7l21.75.61c.86,0,1.72.15,2.58.23.21,5-.2,9.91-.35,14.87-3.26-.69-6.58-.4-9.87-.55-4.39-.19-8.79-.34-13.18-.49a7.9,7.9,0,0,0-1.44.19C842,362.6,842.13,357.65,842.5,352.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M848.43,383.72a97.49,97.49,0,0,1,10.25.32c-1.45.1-1.88.9-1.89,2.3,0,3.68-.23,7.35-.32,11,0,1.26,0,2.57-1.43,3.1-1.89.74-3.84,1.83-5.88.53-1-.65-1.08-1.84-1-3q.27-6.43.48-12.86A10.12,10.12,0,0,0,848.43,383.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M842.5,352.7c-.37,4.95-.47,9.9-.51,14.86-.15,4.4-.33,8.81-.45,13.21,0,1.8.67,2.5,2.53,2.67,1.45.12,2.93-.16,4.36.29-2.47.76-5,.28-7.45,0-1.32-.14-1.44-1.33-1.41-2.43.11-3.8.22-7.6.35-11.4.26-7.54.6-15.08.79-22.62A12.61,12.61,0,0,1,848,335.64c1.58-.8,3.52-1.55,5.47-.69-3.22.76-6.11,2.05-8.22,4.77a13.09,13.09,0,0,0-2.67,8C842.54,349.4,842.52,351.05,842.5,352.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M854.63,334.88c-.38.17-.77.35-1.18.07A1,1,0,0,1,854.63,334.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1175.31,555.89c-7,28.45-24.26,48.18-52.8,56.9-31.62,9.66-59.69,2-83.39-20.91a69.92,69.92,0,0,1-17.78-28.78,7.31,7.31,0,0,0-3.66-4.44c-7.62-4.17-15.2-8.44-22.79-12.68-2-1.1-4.2-2.19-4.17-4.73s2.35-3.42,4.4-4.39c7-3.33,14-6.75,21-10.09a4.67,4.67,0,0,0,2.72-3.42c8.16-33.57,30-53.69,64.22-59.48,49-8.3,95.34,29.43,93.76,80.24A50.35,50.35,0,0,1,1175.31,555.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1106.38,466.2a4.9,4.9,0,0,0,.3-.83,4.9,4.9,0,0,1-.3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1081.06,527.85c.08-4.67.17-9.33.24-14-.07,4.67-.16,9.33-.24,14v.07l-3.2-.6,3.2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1096.31,529l-5.52-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1079.25,507.57h0l1.21-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1091.56,565.47l.63,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1099.88,462.31c-1.31,0-2.62,0-3.93.05C1097.26,462.33,1098.57,462.3,1099.88,462.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1081.21,505l-.65.58-.1.14.09-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1101.66,460.5a26.93,26.93,0,0,0-7.5.08c-.44.06-.83.12-1.19.2.36-.08.75-.14,1.19-.2A26.93,26.93,0,0,1,1101.66,460.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1081.22 504.98 1081.04 505.05 1081.04 505.05 1081.22 504.98 1081.22 504.98 1081.22 504.98 1081.22 504.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1120.1,564.1c0,3.38.12,6.76.14,10.14,0-3.38-.11-6.76-.14-10.14l.06-36.13c0-1.66,0-3.32,0-5,0,1.66,0,3.32,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1076.77,545.68l0,18.19c0,2.8.06,5.61.06,8.42,0-2.81-.07-5.62-.06-8.42Q1076.75,554.78,1076.77,545.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1094.16,460.58a2.41,2.41,0,0,0-.06.5,1.73,1.73,0,0,0,0,.41,1,1,0,0,0,.32.55,1.08,1.08,0,0,0,.28.16,3.06,3.06,0,0,0,1.21.16c1.31,0,2.62-.06,3.93-.05.87,0,1.74,0,2.61.09a30.14,30.14,0,0,1,3.89.47,1.74,1.74,0,0,0-1.58-1.79l-.85-.19-1.22-.23-1.07-.16A26.93,26.93,0,0,0,1094.16,460.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1103,464.32c-.42-.13-.85-.26-1.27-.36a15.6,15.6,0,0,0-1.91-.34l-.64-.05h-.64a9.76,9.76,0,0,0-1.93.22c-.22.05-.43.1-.65.17a9.8,9.8,0,0,0-2,.81h10.27C1103.88,464.6,1103.45,464.45,1103,464.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1151,473.85c-18.69-17.91-41.31-25.22-66.85-20.47-31,5.76-51.3,24.2-60.45,54.53a5.87,5.87,0,0,1-3.23,4c-8.57,4.28-17.09,8.67-25.6,13.06-1.82.94-4.26,1.41-4.35,4.11-.1,2.91,2.35,3.79,4.3,5,.36.23.76.4,1.13.6,9,5,18,10.08,27.07,15a6.41,6.41,0,0,1,3.13,3.73,67.82,67.82,0,0,0,13.76,22.45c17.46,18.82,39,27.37,64.66,25.21A73.66,73.66,0,0,0,1151.8,579c14.18-14.25,21.55-31.64,21.61-55.44C1173.4,506.15,1166,488.19,1151,473.85ZM1120.3,520c-.07.65-.12,1.31-.14,2,0,.34,0,.67,0,1,0,1.66,0,3.32,0,5l-.06,36.13c0,3.38.12,6.76.14,10.14q0,3-.07,6.08a8.8,8.8,0,0,1-6.1,8.5,42.76,42.76,0,0,1-31.39-.62c-4-1.59-6.42-4.52-6.08-9.38.08-1.24.13-2.48.16-3.73,0-.93,0-1.87,0-2.8,0-2.81-.07-5.62-.06-8.42l0-18.19,0-18.3c0-2.41,0-4.81,0-7.22,0-1.21,0-2.43,0-3.64s0-2.41,0-3.62a6.52,6.52,0,0,1,.21-1.48,9.86,9.86,0,0,1,2.24-3.84h0l1.21-1.85.1-.14.65-.58h0v0h0l-.18.07h0a.85.85,0,0,1,.25-.53c7.3-8.62,6.59-19.63,8.8-29.76a21.72,21.72,0,0,0,.31-8.81,11.2,11.2,0,0,1-.22-1.9c0-2,.83-2.83,2.79-3.26.36-.08.75-.14,1.19-.2a26.93,26.93,0,0,1,7.5-.08l1.07.16,1.22.23.85.19a1.74,1.74,0,0,1,1.58,1.79,2.47,2.47,0,0,1,.17.42,3.61,3.61,0,0,1,.13,2.08,4.9,4.9,0,0,1-.3.83c-.1.65-.19,1.3-.29,1.95.4,8,2.67,15.67,3.43,23.57.47,4.87,3,8.6,5.88,12.1A21,21,0,0,1,1120.3,520Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1109.52,491.72c-.76-7.9-3-15.6-3.43-23.57-3.59,1.29-7.29.3-10.93.5-1.08.06-1.19-1-1.18-1.87,0-1.17.83-1.35,1.73-1.37,3.58-.09,7.17-.32,10.67.79a4.9,4.9,0,0,0,.3-.83,3.61,3.61,0,0,0-.13-2.08,2.47,2.47,0,0,0-.17-.42,30.14,30.14,0,0,0-3.89-.47c-.87-.06-1.74-.08-2.61-.09-1.31,0-2.62,0-3.93.05a3.06,3.06,0,0,1-1.21-.16,1.08,1.08,0,0,1-.28-.16,1,1,0,0,1-.32-.55,1.73,1.73,0,0,1,0-.41,2.41,2.41,0,0,1,.06-.5c-.44.06-.83.12-1.19.2-2,.43-2.82,1.28-2.79,3.26a11.2,11.2,0,0,0,.22,1.9,21.72,21.72,0,0,1-.31,8.81c-2.21,10.13-1.5,21.14-8.8,29.76-.08.18-.17.36-.25.53h0l.18-.06h0v0h0l-.66.59-.09.13c0,.9,0,1.73-1.21,1.85h0c-1.83,5.25-1.28,10.66-1.28,16,0,1.24,0,2.48-.12,3.71l3.2.6v-.07c.08-4.67.17-9.33.24-14,.06-3.7,1.38-5.4,4.29-5.47s4.48,1.72,4.52,5.57c.06,4.88.09,9.76.13,14.65a.82.82,0,0,1,.55.24l5.52.12c1.83,0,3.67,0,5.51,0a152.14,152.14,0,0,0,18.34-1c0-1.66,0-3.32,0-5,0-.33,0-.66,0-1,0-.66.07-1.32.14-2a21,21,0,0,0-4.9-16.2C1112.56,500.32,1110,496.59,1109.52,491.72ZM1096,464c.22-.07.43-.12.65-.17a9.76,9.76,0,0,1,1.93-.22h.64l.64.05a15.6,15.6,0,0,1,1.91.34c.42.1.85.23,1.27.36s.85.28,1.27.44H1094A9.8,9.8,0,0,1,1096,464Zm-2.8,22.4c-.28,1.51-.55,3.15-.89,4.79a1,1,0,0,1-1.12.87c-.63-.11-.75-.68-.66-1.22.27-1.65.54-3.3.88-4.93.11-.58.22-1.43,1-1.37C1093.48,484.57,1093.14,485.52,1093.19,486.35Zm2.14-13.23c-.37,2.36-.69,4.33-1,6.3-.1.71-.45,1.24-1.21,1.11s-.8-.85-.69-1.49c.35-2,.73-3.92,1.09-5.88.13-.73.26-1.68,1.21-1.49S1095.41,472.79,1095.33,473.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1090.82,537.91c0,1.52,0,3,0,4.54,0,7.56-.16,15.12-.68,22.67a1.77,1.77,0,0,0,.21.41l1.21-.06.63,0,.26-.1.21.18c9.2.64,18.38.63,27.44-1.42l.06-36.13a152.14,152.14,0,0,1-18.34,1c-1.84,0-3.68,0-5.51,0l-5.52-.12C1090.8,531.87,1090.82,534.89,1090.82,537.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1092.66,565.52l-.25.05-.19-.11,0,0h0l-.63,0-1.21.06h0a52.69,52.69,0,0,1-.18,5.63c-.36,2.64-1.94,4.21-4.73,4s-4.1-1.84-4.12-4.6c0-2,0-4,0-6a.43.43,0,0,1-.29-.25l-4.28-.47c0,2.8.06,5.61.06,8.42,0,.93,0,1.87,0,2.8,0,1.25-.08,2.49-.16,3.73-.34,4.86,2.09,7.79,6.08,9.38a42.76,42.76,0,0,0,31.39.62,8.8,8.8,0,0,0,6.1-8.5q.11-3,.07-6.08c0-3.38-.11-6.76-.14-10.14C1111,566.15,1101.86,566.16,1092.66,565.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1081,564.34c.4-12.14.29-24.28,0-36.42l-3.2-.6-1,.06,0,18.3q0,9.11,0,18.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1095.71,465.41c-.9,0-1.71.2-1.73,1.37,0,.9.1,1.93,1.18,1.87,3.64-.2,7.34.79,10.93-.5.1-.65.19-1.3.29-1.95h0C1102.88,465.09,1099.29,465.32,1095.71,465.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1078,523.61c0-5.37-.55-10.78,1.28-16h0a9.86,9.86,0,0,0-2.24,3.84,6.52,6.52,0,0,0-.21,1.48c0,1.21,0,2.41,0,3.62s0,2.43,0,3.64c0,2.41,0,4.81,0,7.22l1-.06C1077.94,526.09,1078,524.85,1078,523.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1080.46,505.72l-1.21,1.85h0C1080.41,507.45,1080.48,506.62,1080.46,505.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1081,505c.08-.17.17-.35.25-.53A.85.85,0,0,0,1081,505Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1081.05,527.92c.24,12.14.35,24.28,0,36.42a.43.43,0,0,0,.29.25l8.85.53c.52-7.55.66-15.11.68-22.67,0-1.51,0-3,0-4.54,0-3,0-6,0-9.07h0a.82.82,0,0,0-.55-.24l-9.18-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1090.24,528.6c0-4.89-.07-9.77-.13-14.65,0-3.85-1.51-5.65-4.52-5.57s-4.23,1.77-4.29,5.47c-.07,4.67-.16,9.33-.24,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1094.74,471.67c-1-.19-1.08.76-1.21,1.49-.36,2-.74,3.92-1.09,5.88-.11.64-.14,1.35.69,1.49s1.11-.4,1.21-1.11c.3-2,.62-3.94,1-6.3C1095.41,472.79,1095.72,471.86,1094.74,471.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1092.4,484.49c-.78-.06-.89.79-1,1.37-.34,1.63-.61,3.28-.88,4.93-.09.54,0,1.11.66,1.22a1,1,0,0,0,1.12-.87c.34-1.64.61-3.28.89-4.79C1093.14,485.52,1093.48,484.57,1092.4,484.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1081.29,564.59c0,2,0,4,0,6,0,2.76,1.35,4.41,4.12,4.6s4.37-1.38,4.73-4a52.69,52.69,0,0,0,.18-5.63h0a1.77,1.77,0,0,1-.21-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1092.19,565.44h0l0,0,.19.11.25-.05-.21-.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1037.61,389.42c11.53,19,13,38.8,2.63,58.56-11.46,21.9-30.28,32.58-55,32.73a52.79,52.79,0,0,1-24.69-6.13,5.46,5.46,0,0,0-4.29-.47c-6.23,1.77-12.49,3.46-18.73,5.18-1.62.45-3.38,1-4.72-.35s-.59-3.08,0-4.68c1.9-5.5,3.74-11,5.63-16.52a3.54,3.54,0,0,0-.4-3.28c-13.62-22.41-12.88-44.81,2-66a59.27,59.27,0,0,1,92-6.19A39,39,0,0,1,1037.61,389.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1041.17,412.75c0,27.69-13.78,48.31-35.18,57.05q-25.26,10.31-49.65-2.06a6.39,6.39,0,0,0-4.84-.52c-6.1,1.57-12.24,3-18.37,4.48a12.22,12.22,0,0,1-1.9.35c-3.31.27-4.54-1.24-3.4-4.41q3-8.2,6.19-16.33a4.67,4.67,0,0,0-.38-4.69,55.74,55.74,0,0,1,5.77-65.87,56.42,56.42,0,0,1,38.09-19.49c17.21-1.66,32.3,3.21,45.12,14.78C1034.85,387.09,1040.86,401,1041.17,412.75Zm-91.11,22.18.09.07c-.39.75.18,1.18.55,1.7a35,35,0,0,0,8.93,8.44A41.48,41.48,0,0,0,985.39,452c9.37-.48,18-3.54,25.15-10,7.7-6.91,11.24-15.4,10.05-25.71-.13-1.14.15-2.71-1.3-3.46a.22.22,0,0,0-.32,0c-.15-.79-.24-1.6-.45-2.37-2.83-10.55-9.88-17.32-19.53-21.75l-1.13-.47c-12-4.56-23.88-4.4-35.41,1.22-9.06,4.41-15.83,11-17.9,21.42a6.54,6.54,0,0,0-.41,1.12c-1.57,8.17.93,15.36,5.37,22.07C949.45,434.5,949.43,434.92,950.06,434.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M944.55,410.87c2.07-10.39,8.84-17,17.9-21.42,11.53-5.62,23.43-5.78,35.41-1.22a6.13,6.13,0,0,1-.68.24c-.74.15-1.87-.13-1.75,1.1s1.33.83,2.13.9c1.28.1,1.34-.86,1.43-1.77,9.65,4.43,16.7,11.2,19.53,21.75.21.77.3,1.58.45,2.37-.57,12-7.18,20-17.44,25.15-11.34,5.71-23.17,6.09-35.09,1.95C952.53,435.09,945.37,425.45,944.55,410.87Zm50.57-2.95a2.91,2.91,0,0,0-.78-1.73c-5.54-8.23-19.68-8.22-25.16.06-2.06,3.11-2.72,6.46-.9,10a6.54,6.54,0,0,0,1.59,2.95c5.82,7.19,18.55,7,24.08-.39C996.44,415.46,997.12,411.8,995.12,407.92Zm-40.69-7.36c1.15,0,2,0,2.09-.94.09-1.17-.91-1.11-1.71-1.14s-1.63,0-1.69.95C953.05,400.55,954,400.55,954.43,400.56Zm38.75,25.13c.78-.05,1.78.09,1.75-1.06,0-.9-.86-1-1.62-1s-1.74-.08-1.73,1.07S992.48,425.63,993.18,425.69Zm-13.64-36.48c.79,0,1.7,0,1.7-1s-1-1.09-1.78-1.1-1.62,0-1.63,1C977.81,389.27,978.83,389.13,979.54,389.21Zm23,15.31c.79,0,1.57-.3,1.58-1.13s-.79-1.16-1.56-1.17-1.58.33-1.59,1.14S1001.76,404.52,1002.58,404.52Zm-51,10.55c.77,0,1.71,0,1.65-1.13,0-1-.92-1-1.64-1s-1.75,0-1.7,1.14C950,415.08,950.86,415,951.61,415.07ZM982.14,438c.77,0,1.77.13,1.78-1,0-1-.83-1.06-1.56-1s-1.78-.07-1.8,1.06C980.54,437.92,981.39,438,982.14,438Zm29.5-33.54c.41,0,1.34,0,1.34-1.09s-.89-1-1.61-1-1.75-.08-1.73,1.07C1009.65,404.41,1010.5,404.41,1011.64,404.42Zm-5,17.56c.68-.19,1.53-.35,1.42-1.28s-.87-1.08-1.65-1-1.54.37-1.45,1.23S1005.8,421.93,1006.59,422Zm3.86,5.35c.77-.06,1.79.18,1.92-.94s-.77-1.05-1.51-1.07-1.78-.19-1.9.92S1009.69,427.32,1010.45,427.33ZM965.07,394.1c.71-.1,1.72.08,1.76-1.05s-.84-1-1.56-1-1.75-.07-1.79,1S964.29,394.07,965.07,394.1Zm22,39.12c.79,0,1.56-.23,1.57-1.1s-.79-1.15-1.54-1.17-1.57.28-1.58,1.12S986.27,433.22,987.08,433.22Zm14.38-17.55c1,0,1.89,0,1.87-1,0-1.14-1-1-1.8-1s-1.61,0-1.59,1C1000,415.88,1001,415.63,1001.46,415.67ZM970.3,426.51a1.49,1.49,0,0,0-1.61-1c-.81,0-1.53.3-1.51,1.16s.79,1.14,1.55,1.13A1.41,1.41,0,0,0,970.3,426.51Zm30.25.53c-.7.2-1.57.34-1.45,1.28s.86,1.07,1.65,1,1.56-.27,1.45-1.2S1001.3,427.12,1000.55,427Zm-37.34-27.36c.49-.18,1.32-.31,1.21-1.26s-.89-1.06-1.63-1-1.52.34-1.42,1.25S962.23,399.69,963.21,399.68Zm-9.49,5.9c-.6.15-1.44.31-1.42,1.2s.8,1.12,1.57,1.13,1.56-.35,1.55-1.16S954.61,405.66,953.72,405.58Zm10.16,3.29c-.7,0-1.64-.11-1.72.83-.09,1.1.86,1.15,1.69,1.15s1.77,0,1.71-1.11C965.5,408.77,964.58,408.91,963.88,408.87Zm9.37-18.9c-.71,0-1.49.18-1.55,1.08s.68,1.19,1.45,1.19,1.54-.17,1.59-1.06S974.06,390,973.25,390Zm14.52,2.46c.18.91.87,1.09,1.62,1.09s1.55-.24,1.52-1.15-.84-1.08-1.58-1.07S987.88,391.49,987.77,392.43ZM965,435.65c.74,0,1.6,0,1.57-1,0-1.17-1-1-1.81-1s-1.62,0-1.58,1C963.2,435.81,964.21,435.61,965,435.65Zm36-38.39c.8,0,1.78.05,1.69-1.1-.08-.92-1-.89-1.7-.88s-1.77,0-1.68,1.12C999.36,397.37,1000.26,397.24,1001,397.26Zm-3.3,34.47c-.72,0-1.61,0-1.61,1,0,1.18,1,1,1.75,1s1.59,0,1.59-1C999.4,431.61,998.41,431.79,997.67,431.73ZM977,427.85c-.72,0-1.62,0-1.61,1,0,1.15,1,1,1.81,1s1.62,0,1.6-1C978.76,427.74,977.76,427.9,977,427.85Zm18.18-25.71c.77-.05,1.76,0,1.68-1.14-.07-1-1-.82-1.71-.84s-1.59,0-1.59,1S994.41,402.1,995.16,402.14Zm-11.62-5.83c.79,0,1.75.06,1.7-1.08,0-1-.93-.9-1.64-.89s-1.76-.09-1.7,1.07C982,396.38,982.83,396.3,983.54,396.31Zm-31.27,30c.6-.07,1.49,0,1.47-1s-.93-.92-1.62-.92-1.66-.18-1.71.83C950.35,426.41,951.37,426.27,952.27,426.34Zm4.89-4.34c.58-.16,1.41-.22,1.46-1.14s-.71-1.15-1.46-1.2-1.54.24-1.59,1.08S956.3,421.85,957.16,422Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M944.55,410.87c.82,14.58,8,24.22,21.89,29.05,11.92,4.14,23.75,3.76,35.09-1.95,10.26-5.17,16.87-13.13,17.44-25.15a.22.22,0,0,1,.32,0c0,1.13-.08,2.26-.08,3.39,0,9.92-4.33,17.79-12.05,23.68-14.47,11-34.73,11.34-49.86,1.19-2.64-1.77-4.51-4.35-7.15-6.07l-.1-.06-.54-.88c-4.44-6.71-6.94-13.9-5.37-22.07A6.54,6.54,0,0,1,944.55,410.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M950.15,435c2.64,1.72,4.51,4.3,7.15,6.07,15.13,10.15,35.39,9.84,49.86-1.19,7.72-5.89,12-13.76,12.05-23.68,0-1.13,0-2.26.08-3.39,1.45.75,1.17,2.32,1.3,3.46,1.19,10.31-2.35,18.8-10.05,25.71-7.17,6.45-15.78,9.51-25.15,10a41.48,41.48,0,0,1-25.76-6.83,35,35,0,0,1-8.93-8.44C950.33,436.18,949.76,435.75,950.15,435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M995.12,407.92c2,3.88,1.32,7.54-1.17,10.87-5.53,7.42-18.26,7.58-24.08.39a6.54,6.54,0,0,1-1.59-2.95c1-1.4.74-3.2,1.51-4.73,4.45-8.84,15.67-9.84,22.76-5.22C993.4,406.83,993.89,408,995.12,407.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M995.12,407.92c-1.23,0-1.72-1.09-2.57-1.64-7.09-4.62-18.31-3.62-22.76,5.22-.77,1.53-.48,3.33-1.51,4.73-1.82-3.52-1.16-6.87.9-10,5.48-8.28,19.62-8.29,25.16-.06A2.91,2.91,0,0,1,995.12,407.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M954.43,400.56c-.41,0-1.38,0-1.31-1.13.06-.91,1-1,1.69-.95s1.8,0,1.71,1.14C956.46,400.56,955.58,400.56,954.43,400.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M993.18,425.69c-.7-.06-1.59,0-1.6-1s.92-1.07,1.73-1.07,1.59.1,1.62,1C995,425.78,994,425.64,993.18,425.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1002.58,404.51c-.82,0-1.58-.34-1.57-1.15s.81-1.16,1.59-1.14,1.58.33,1.56,1.17S1003.37,404.5,1002.58,404.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M951.61,415.07c-.75-.05-1.64,0-1.69-1,0-1.14.9-1.14,1.7-1.14s1.59,0,1.64,1C953.32,415.09,952.38,415.05,951.61,415.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M982.14,438c-.75,0-1.6,0-1.58-1,0-1.13,1-1,1.8-1.06s1.58.06,1.56,1C983.91,438.09,982.91,437.92,982.14,438Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1011.64,404.42c-1.14,0-2,0-2-1,0-1.15.93-1.08,1.73-1.07s1.6,0,1.61,1S1012.05,404.41,1011.64,404.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1006.59,422c-.79-.05-1.59-.25-1.68-1.08s.67-1.18,1.45-1.23,1.54.19,1.65,1S1007.27,421.79,1006.59,422Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1010.45,427.33c-.76,0-1.61-.1-1.49-1.09s1.11-.94,1.9-.92,1.63.05,1.51,1.07S1011.22,427.27,1010.45,427.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M965.07,394.1c-.78,0-1.63-.07-1.59-1s1-1.06,1.79-1,1.59,0,1.56,1S965.78,394,965.07,394.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M987.08,433.22c-.81,0-1.57-.31-1.55-1.15s.81-1.14,1.58-1.12,1.57.28,1.54,1.17S987.87,433.22,987.08,433.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1001.46,415.67c-.49,0-1.51.21-1.52-1,0-1,.87-1,1.59-1s1.79-.14,1.8,1C1003.35,415.67,1002.49,415.7,1001.46,415.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M970.3,426.51a1.41,1.41,0,0,1-1.57,1.25c-.76,0-1.54-.25-1.55-1.13s.7-1.16,1.51-1.16A1.49,1.49,0,0,1,970.3,426.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1000.55,427c.75.08,1.55.25,1.65,1.09s-.67,1.15-1.45,1.2-1.55-.15-1.65-1S999.85,427.24,1000.55,427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M963.21,399.68c-1,0-1.74-.2-1.84-1s.66-1.21,1.42-1.25,1.52.15,1.63,1S963.7,399.5,963.21,399.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M953.72,405.58c.89.08,1.7.33,1.7,1.17s-.74,1.16-1.55,1.16-1.55-.26-1.57-1.13S953.12,405.73,953.72,405.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M963.88,408.87c.7,0,1.62-.1,1.68.87.06,1.14-.91,1.1-1.71,1.11s-1.78-.05-1.69-1.15C962.24,408.76,963.18,408.9,963.88,408.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M973.25,390c.81.06,1.55.31,1.49,1.21s-.85,1.06-1.59,1.06-1.51-.28-1.45-1.19S972.54,390,973.25,390Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M987.77,392.43c.11-.94.81-1.12,1.56-1.13s1.56.16,1.58,1.07-.76,1.14-1.52,1.15S988,393.34,987.77,392.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M965,435.65c-.77,0-1.78.16-1.82-1,0-1,.84-1,1.58-1s1.77-.19,1.81,1C966.58,435.66,965.72,435.66,965,435.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1001,397.26c-.71,0-1.61.11-1.69-.86-.09-1.16.88-1.11,1.68-1.12s1.62,0,1.7.88C1002.75,397.31,1001.77,397.25,1001,397.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M997.67,431.73c.74.06,1.73-.12,1.73,1,0,1-.87,1-1.59,1s-1.75.15-1.75-1C996.06,431.69,997,431.78,997.67,431.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M977,427.85c.78,0,1.78-.11,1.8,1,0,1-.87,1-1.6,1s-1.79.15-1.81-1C975.36,427.88,976.26,427.9,977,427.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M995.16,402.14c-.75,0-1.63,0-1.62-1s.86-1,1.59-1,1.64-.17,1.71.84C996.92,402.16,995.93,402.09,995.16,402.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M983.54,396.31c-.71,0-1.59.07-1.64-.9-.06-1.16.91-1.07,1.7-1.07s1.59-.08,1.64.89C985.29,396.37,984.33,396.29,983.54,396.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M952.27,426.34c-.9-.07-1.92.07-1.86-1.11.05-1,1-.83,1.71-.83s1.6-.15,1.62.92S952.87,426.27,952.27,426.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M957.16,422c-.86-.15-1.65-.38-1.59-1.26s.8-1.13,1.59-1.08,1.51.27,1.46,1.2S957.74,421.84,957.16,422Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M737.94,0h-300c-10.19,0-18.48,8.58-18.48,19.12v464c0,10.54,8.29,19.11,18.48,19.11h300c10.19,0,18.48-8.57,18.48-19.11v-464C756.42,8.58,748.13,0,737.94,0Zm0,499.64h-300c-8.8,0-15.95-7.4-15.95-16.5V38.3H753.89V483.14C753.89,492.24,746.74,499.64,737.94,499.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 470.6,
    y: 160.63,
    width: 233.64,
    height: 78.55,
    rx: 29.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 438,
    y: 247.49,
    width: 298.84,
    height: 88.46,
    rx: 29.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 462.25,
    y: 271.49,
    width: 69.2,
    height: 53.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 462.63,
    y: 255.3,
    width: 69.2,
    height: 2.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 462.63,
    y: 254.65,
    width: 69.2,
    height: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 468,
    y: 279.11,
    width: 38.87,
    height: 28.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 473.53,
    y: 274.59,
    width: 27.81,
    height: 37.99,
    transform: "translate(781.02 -193.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 473.89,
    y: 275.09,
    width: 27.08,
    height: 37,
    transform: "translate(781.02 -193.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 475.29,
    y: 276.67,
    width: 24.3,
    height: 33.83,
    transform: "translate(781.02 -193.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "472.38 283.33 504.35 282.01 504.35 281.44 470.52 281.44 470.52 305.73 471.06 305.73 472.38 283.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 460.62,
    y: 321,
    width: 73.23,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 461.33,
    y: 319.89,
    width: 71.8,
    height: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 508.64,
    y: 277.25,
    width: 21.21,
    height: 43.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M455.51,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.38A3.19,3.19,0,0,0,455.51,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M461.87,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.38A3.19,3.19,0,0,0,461.87,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M468.23,275.27a3.19,3.19,0,0,0,3.19-3.19H465A3.19,3.19,0,0,0,468.23,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M474.59,275.27a3.19,3.19,0,0,0,3.19-3.19H471.4A3.19,3.19,0,0,0,474.59,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M481,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.38A3.19,3.19,0,0,0,481,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M487.31,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.37A3.18,3.18,0,0,0,487.31,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M493.67,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.37A3.18,3.18,0,0,0,493.67,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M500,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.37A3.18,3.18,0,0,0,500,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M506.39,275.27a3.19,3.19,0,0,0,3.19-3.19h-6.37A3.18,3.18,0,0,0,506.39,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M512.76,275.27a3.18,3.18,0,0,0,3.18-3.19h-6.37A3.19,3.19,0,0,0,512.76,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M519.12,275.27a3.18,3.18,0,0,0,3.18-3.19h-6.37A3.19,3.19,0,0,0,519.12,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M525.48,275.27a3.18,3.18,0,0,0,3.18-3.19h-6.37A3.19,3.19,0,0,0,525.48,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M531.84,275.27a3.18,3.18,0,0,0,3.18-3.19h-6.37A3.19,3.19,0,0,0,531.84,275.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M538.2,275.27a3.19,3.19,0,0,0,3.19-3.19H535A3.19,3.19,0,0,0,538.2,275.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 484.14,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 471.42,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 477.78,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 490.5,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 452.34,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 458.7,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 465.06,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 522.29,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 528.66,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 515.94,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 535.01,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 509.57,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 503.22,
    y: 256.71,
    width: 6.35,
    height: 15.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 496.86,
    y: 256.71,
    width: 6.37,
    height: 15.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "473.53 284.13 472.53 299.17 488.64 283.31 473.53 284.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "490.64 283.31 472.61 301.04 472.61 301.04 493.03 283.17 490.64 283.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 509.64,
    y: 278.37,
    width: 19.29,
    height: 46.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 511.34,
    y: 280.12,
    width: 16.11,
    height: 40.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 514.26,
    y: 283.1,
    width: 10.89,
    height: 23.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "514.26 283.1 514.26 306.39 515.23 284.01 525.15 283.1 514.26 283.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "524.75 283.7 515.8 284.61 515.58 295.36 524.75 283.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "524.75 284.97 515.58 296.67 524.75 286.59 524.75 284.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 494.1,
    y: 185.11,
    width: 56.28,
    height: 43.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 494.4,
    y: 171.94,
    width: 56.28,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 494.4,
    y: 171.42,
    width: 56.28,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 498.78,
    y: 191.31,
    width: 31.61,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 503.27,
    y: 187.63,
    width: 22.61,
    height: 30.89,
    transform: "translate(717.66 -311.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 503.57,
    y: 188.03,
    width: 22.03,
    height: 30.09,
    transform: "translate(717.66 -311.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 504.7,
    y: 189.32,
    width: 19.76,
    height: 27.51,
    transform: "translate(717.66 -311.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "502.34 194.74 528.34 193.67 528.34 193.2 500.82 193.2 500.82 212.96 501.26 212.96 502.34 194.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 492.77,
    y: 225.38,
    width: 59.55,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 493.35,
    y: 224.47,
    width: 58.39,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 531.83,
    y: 189.79,
    width: 17.25,
    height: 35.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M488.62,188.18a2.59,2.59,0,0,0,2.59-2.59H486A2.59,2.59,0,0,0,488.62,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M493.79,188.18a2.59,2.59,0,0,0,2.59-2.59H491.2A2.59,2.59,0,0,0,493.79,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M499,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,499,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M504.14,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.19A2.59,2.59,0,0,0,504.14,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M509.31,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,509.31,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M514.48,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,514.48,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M519.65,188.18a2.59,2.59,0,0,0,2.6-2.59h-5.19A2.59,2.59,0,0,0,519.65,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M524.83,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,524.83,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M530,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,530,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M535.17,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,535.17,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M540.35,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.19A2.59,2.59,0,0,0,540.35,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M545.52,188.18a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,545.52,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M550.69,188.18a2.59,2.59,0,0,0,2.59-2.59H548.1A2.59,2.59,0,0,0,550.69,188.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M555.86,188.18a2.59,2.59,0,0,0,2.6-2.59h-5.19A2.59,2.59,0,0,0,555.86,188.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 511.9,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 501.55,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 506.73,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 517.07,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 486.04,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 491.21,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 496.38,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 542.93,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 548.11,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 537.76,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 553.27,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 532.58,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 527.42,
    y: 173.09,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 522.25,
    y: 173.09,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "503.27 195.39 502.46 207.62 515.56 194.72 503.27 195.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "517.19 194.72 502.53 209.14 502.53 209.14 519.13 194.6 517.19 194.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 532.64,
    y: 190.71,
    width: 15.69,
    height: 37.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 534.02,
    y: 192.13,
    width: 13.11,
    height: 33.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 536.4,
    y: 194.55,
    width: 8.86,
    height: 18.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "536.4 194.55 536.4 213.5 537.19 195.29 545.26 194.55 536.4 194.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "544.92 195.04 537.65 195.78 537.47 204.52 544.92 195.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "544.92 196.07 537.47 205.59 544.92 197.39 544.92 196.07"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 470.6,
    y: 73.78,
    width: 233.64,
    height: 78.55,
    rx: 29.86
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 494.1,
    y: 98.25,
    width: 56.28,
    height: 43.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 494.4,
    y: 85.09,
    width: 56.28,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 494.4,
    y: 84.56,
    width: 56.28,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 498.78,
    y: 104.46,
    width: 31.61,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 503.27,
    y: 100.78,
    width: 22.61,
    height: 30.89,
    transform: "translate(630.8 -398.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 503.57,
    y: 101.18,
    width: 22.03,
    height: 30.09,
    transform: "translate(630.8 -398.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 504.7,
    y: 102.47,
    width: 19.76,
    height: 27.51,
    transform: "translate(630.8 -398.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "502.34 107.89 528.34 106.81 528.34 106.34 500.82 106.34 500.82 126.1 501.26 126.1 502.34 107.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 492.77,
    y: 138.52,
    width: 59.55,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 493.35,
    y: 137.62,
    width: 58.39,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 531.83,
    y: 102.94,
    width: 17.25,
    height: 35.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M488.62,101.33a2.59,2.59,0,0,0,2.59-2.59H486A2.59,2.59,0,0,0,488.62,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M493.79,101.33a2.59,2.59,0,0,0,2.59-2.59H491.2A2.59,2.59,0,0,0,493.79,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M499,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,499,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M504.14,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.19A2.59,2.59,0,0,0,504.14,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M509.31,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,509.31,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M514.48,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,514.48,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M519.65,101.33a2.59,2.59,0,0,0,2.6-2.59h-5.19A2.59,2.59,0,0,0,519.65,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M524.83,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,524.83,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M530,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,530,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M535.17,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,535.17,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M540.35,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.19A2.59,2.59,0,0,0,540.35,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M545.52,101.33a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,545.52,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M550.69,101.33a2.59,2.59,0,0,0,2.59-2.59H548.1A2.59,2.59,0,0,0,550.69,101.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M555.86,101.33a2.59,2.59,0,0,0,2.6-2.59h-5.19A2.59,2.59,0,0,0,555.86,101.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 511.9,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 501.55,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 506.73,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 517.07,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 486.04,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 491.21,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 496.38,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 542.93,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 548.11,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 537.76,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 553.27,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 532.58,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 527.42,
    y: 86.23,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 522.25,
    y: 86.23,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "503.27 108.53 502.46 120.76 515.56 107.87 503.27 108.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "517.19 107.87 502.53 122.28 502.53 122.28 519.13 107.75 517.19 107.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 532.64,
    y: 103.85,
    width: 15.69,
    height: 37.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 534.02,
    y: 105.28,
    width: 13.11,
    height: 33.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 536.4,
    y: 107.7,
    width: 8.86,
    height: 18.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "536.4 107.7 536.4 126.64 537.19 108.44 545.26 107.7 536.4 107.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "544.92 108.18 537.65 108.92 537.47 117.67 544.92 108.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "544.92 109.22 537.47 118.73 544.92 110.53 544.92 109.22"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 470.6,
    y: 345.17,
    width: 233.64,
    height: 78.55,
    rx: 29.86
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 494.1,
    y: 369.65,
    width: 56.28,
    height: 43.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 494.4,
    y: 356.48,
    width: 56.28,
    height: 1.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 494.4,
    y: 355.96,
    width: 56.28,
    height: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 498.78,
    y: 375.85,
    width: 31.61,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 503.27,
    y: 372.17,
    width: 22.61,
    height: 30.89,
    transform: "translate(902.2 -126.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 503.57,
    y: 372.57,
    width: 22.03,
    height: 30.09,
    transform: "translate(902.2 -126.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 504.7,
    y: 373.86,
    width: 19.76,
    height: 27.51,
    transform: "translate(902.2 -126.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "502.34 379.28 528.34 378.21 528.34 377.74 500.82 377.74 500.82 397.5 501.26 397.5 502.34 379.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 492.77,
    y: 409.92,
    width: 59.55,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 493.35,
    y: 409.01,
    width: 58.39,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 531.83,
    y: 374.33,
    width: 17.25,
    height: 35.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M488.62,372.72a2.59,2.59,0,0,0,2.59-2.59H486A2.59,2.59,0,0,0,488.62,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M493.79,372.72a2.59,2.59,0,0,0,2.59-2.59H491.2A2.59,2.59,0,0,0,493.79,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M499,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,499,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M504.14,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.19A2.59,2.59,0,0,0,504.14,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M509.31,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,509.31,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M514.48,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,514.48,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M519.65,372.72a2.59,2.59,0,0,0,2.6-2.59h-5.19A2.59,2.59,0,0,0,519.65,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M524.83,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,524.83,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M530,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,530,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M535.17,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,535.17,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M540.35,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.19A2.59,2.59,0,0,0,540.35,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M545.52,372.72a2.59,2.59,0,0,0,2.59-2.59h-5.18A2.59,2.59,0,0,0,545.52,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M550.69,372.72a2.59,2.59,0,0,0,2.59-2.59H548.1A2.59,2.59,0,0,0,550.69,372.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M555.86,372.72a2.59,2.59,0,0,0,2.6-2.59h-5.19A2.59,2.59,0,0,0,555.86,372.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 511.9,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 501.55,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 506.73,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 517.07,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 486.04,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 491.21,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 496.38,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 542.93,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 548.11,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 537.76,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 553.27,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 532.58,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 527.42,
    y: 357.63,
    width: 5.16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 522.25,
    y: 357.63,
    width: 5.18,
    height: 12.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "503.27 379.93 502.46 392.16 515.56 379.26 503.27 379.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "517.19 379.26 502.53 393.68 502.53 393.68 519.13 379.14 517.19 379.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 532.64,
    y: 375.24,
    width: 15.69,
    height: 37.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 534.02,
    y: 376.67,
    width: 13.11,
    height: 33.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 536.4,
    y: 379.09,
    width: 8.86,
    height: 18.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "536.4 379.09 536.4 398.04 537.19 379.83 545.26 379.09 536.4 379.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "544.92 379.57 537.65 380.32 537.47 389.06 544.92 379.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "544.92 380.61 537.47 390.13 544.92 381.93 544.92 380.61"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "568.66 256.71 570.92 263.66 578.23 263.66 572.32 267.96 574.58 274.92 568.66 270.62 562.75 274.92 565.01 267.96 559.09 263.66 566.4 263.66 568.66 256.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "592.55 256.71 594.81 263.66 602.12 263.66 596.21 267.96 598.47 274.92 592.55 270.62 586.63 274.92 588.89 267.96 582.98 263.66 590.29 263.66 592.55 256.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "616.44 256.71 618.7 263.66 626.01 263.66 620.09 267.96 622.35 274.92 616.44 270.62 610.52 274.92 612.78 267.96 606.87 263.66 614.18 263.66 616.44 256.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "640.33 256.71 642.58 263.66 649.9 263.66 643.98 267.96 646.24 274.92 640.33 270.62 634.41 274.92 636.67 267.96 630.75 263.66 638.07 263.66 640.33 256.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "664.21 256.71 666.47 263.66 673.78 263.66 667.87 267.96 670.13 274.92 664.21 270.62 658.3 274.92 660.56 267.96 654.64 263.66 661.95 263.66 664.21 256.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "577.61 356.48 579.45 362.13 585.39 362.13 580.58 365.63 582.42 371.28 577.61 367.78 572.8 371.28 574.64 365.63 569.83 362.13 575.77 362.13 577.61 356.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "597.02 356.48 598.86 362.13 604.8 362.13 599.99 365.63 601.83 371.28 597.02 367.78 592.22 371.28 594.05 365.63 589.24 362.13 595.19 362.13 597.02 356.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "616.44 356.48 618.27 362.13 624.22 362.13 619.41 365.63 621.25 371.28 616.44 367.78 611.63 371.28 613.47 365.63 608.66 362.13 614.6 362.13 616.44 356.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "635.85 356.48 637.69 362.13 643.63 362.13 638.82 365.63 640.66 371.28 635.85 367.78 631.04 371.28 632.88 365.63 628.07 362.13 634.01 362.13 635.85 356.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "655.27 356.48 657.1 362.13 663.04 362.13 658.24 365.63 660.07 371.28 655.27 367.78 650.46 371.28 652.29 365.63 647.49 362.13 653.43 362.13 655.27 356.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "576.44 171.42 578.28 177.07 584.22 177.07 579.41 180.56 581.25 186.21 576.44 182.72 571.63 186.21 573.47 180.56 568.66 177.07 574.61 177.07 576.44 171.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "595.86 171.42 597.69 177.07 603.63 177.07 598.83 180.56 600.66 186.21 595.86 182.72 591.05 186.21 592.88 180.56 588.08 177.07 594.02 177.07 595.86 171.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "615.27 171.42 617.11 177.07 623.05 177.07 618.24 180.56 620.08 186.21 615.27 182.72 610.46 186.21 612.3 180.56 607.49 177.07 613.43 177.07 615.27 171.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "634.68 171.42 636.52 177.07 642.46 177.07 637.65 180.56 639.49 186.21 634.68 182.72 629.88 186.21 631.71 180.56 626.9 177.07 632.85 177.07 634.68 171.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "654.1 171.42 655.93 177.07 661.88 177.07 657.07 180.56 658.91 186.21 654.1 182.72 649.29 186.21 651.13 180.56 646.32 177.07 652.26 177.07 654.1 171.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "576.44 84.56 578.28 90.21 584.22 90.21 579.41 93.71 581.25 99.36 576.44 95.87 571.63 99.36 573.47 93.71 568.66 90.21 574.61 90.21 576.44 84.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "595.86 84.56 597.69 90.21 603.63 90.21 598.83 93.71 600.66 99.36 595.86 95.87 591.05 99.36 592.88 93.71 588.08 90.21 594.02 90.21 595.86 84.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "615.27 84.56 617.11 90.21 623.05 90.21 618.24 93.71 620.08 99.36 615.27 95.87 610.46 99.36 612.3 93.71 607.49 90.21 613.43 90.21 615.27 84.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "634.68 84.56 636.52 90.21 642.46 90.21 637.65 93.71 639.49 99.36 634.68 95.87 629.88 99.36 631.71 93.71 626.9 90.21 632.85 90.21 634.68 84.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "654.1 84.56 655.93 90.21 661.88 90.21 657.07 93.71 658.91 99.36 654.1 95.87 649.29 99.36 651.13 93.71 646.32 90.21 652.26 90.21 654.1 84.56"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M616.1,198.16H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H616.1a2,2,0,0,1,2,2h0A2,2,0,0,1,616.1,198.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,209.58H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,209.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,216.21H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,216.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,222.86H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,222.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M616.1,119.65H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H616.1a2,2,0,0,1,2,2h0A2,2,0,0,1,616.1,119.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,131.07H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,131.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,137.7H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,137.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,144.35H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,144.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M616.1,387.15H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H616.1a2,2,0,0,1,2,2h0A2,2,0,0,1,616.1,387.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,398.57H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,398.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,405.2H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,405.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M659.34,411.85H573.26a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h86.08a2,2,0,0,1,2,2h0A2,2,0,0,1,659.34,411.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M616.51,295.39h-53.3a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h53.3a2,2,0,0,1,2,2h0A2,2,0,0,1,616.51,295.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M669.4,306.8H563.21a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H669.4a2,2,0,0,1,2,2h0A2,2,0,0,1,669.4,306.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M669.4,313.44H563.21a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H669.4a2,2,0,0,1,2,2h0A2,2,0,0,1,669.4,313.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M669.4,320.08H563.21a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H669.4a2,2,0,0,1,2,2h0A2,2,0,0,1,669.4,320.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "405.47 751.83 382.61 832.08 392.84 832.08 417.77 751.83 405.47 751.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "790.79 751.83 813.66 832.08 803.42 832.08 778.5 751.83 790.79 751.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M451.75,683.18s-7.62,20.81-43.38,21.69-15.26,17-15.26,17,53.89,5.94,58.94,1.83c7.72-6.3-4.4-12.14,11.13-24.74S451.75,683.18,451.75,683.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.41,704.52s3,17.19,10.47,19.23L403,722.67l7.42-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M442.74,694.29s1.32,15,12.2,16.07c0,0,1.7-6.86,4.33-7s-12.94-12.17-12.94-12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M412.48,702.08v24s-46.9,5.44-49.54-8.62,11.43-24.92,27.55-26.09c4.21-.31,7.72-.45,10.61-.5A11.19,11.19,0,0,1,412.48,702.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "364.1 720.12 366.17 731.79 458.49 731.79 458.49 725.96 364.1 720.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M364.23,720.85l48.25,2.26v-5.93s-45.49,4.33-49.86-1.54C362.62,715.64,362.88,719.39,364.23,720.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "507.44 578.25 520.71 583.62 509.3 592.81 507.44 578.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M685.94,716.89s-39.87,13.48-55.11,2.64-77.67-77.67-77.67-77.67S482.53,716,463.62,712.93c0,0-12.75-8.64-17.29-21.69s-6-14.8-6-14.8l78.55-77.38s-6.16-17-11.43-20.81c0,0-.59-2.93,6.74-6.74s92-42.5,102.88-32.53,59.5,93.2,59.5,93.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M513.6,587s-19.94,4.79-22.87,0a42,42,0,0,1-4.3-11.48l-15.82,4.93,10.16,42.8s8.22,5.29,16.89-3.24,23-9.47,23-9.47S522,597.6,513.6,587Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M482.67,580.89s1.84,34.64,9.42,42.9c0,0-9.41,3.41-11.32-1.57s-8.5-36.88-8.5-36.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M520.63,610.49l.08,10s58.54-17,89.61-49.24c0,0-28.34,44.28-92,53.6a72.37,72.37,0,0,1-12.6-1.14c-5.86-1.17-18.11,6.22-18.11,6.22S504.65,609.32,520.63,610.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M596.21,583.61s35,43.94,56.7,62.9c0,0-73.06-49.09-73.75-51.54C579.16,595,594.41,585,596.21,583.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M668.92,647.15s-8.78,14.69-7.9,33.16-21.9,41-39.38,32.06c0,0,20.62,27.77,68.69,7.45C690.33,719.82,684.14,654.14,668.92,647.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M443.21,542.21s14.5-11.05,30.91-3,20.72,29.12,20.13,32.83-16.18,13.34-16.18,13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M480.77,583.61s-15.69-45.09-31.37-44.79a19.29,19.29,0,0,0-11.34,7.27c-4.34,6.08,40,39.25,40,39.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "553.16 641.86 563.13 631.89 560.15 649.29 553.16 641.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M854.76,474.5s-19.34,3.91-24.42,23.45c0,0-5.87,7.42-12.71,8.79s-3.51,4.69,0,8,5.48,8.6,2.35,13.29-7.89,17.58,14.23,28.72c0,0,7.26,3.13,5.11,7.82s-12.77,21.27-12.77,21.27,14.34,15.27,27.43,6.86l12.58-31.89a39.44,39.44,0,0,1,2.09-4.47l15.42-28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M833,575.56s-.51,25.07,22,14.66c0,0,3.9,51.51-16.61,78.48s-67,50-104.15,53-48.26,3.67-48.26,3.67-18.57-39.43-18-65.42,6.84-31.65,6.84-31.65,24,15.43,31.07,11.52c0,0,74.83-27,98.28-51.78C804.15,588,821.2,574.24,833,575.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M719.94,668s3.71,7.17,41.22-1.23c0,0,11.34-3.52,14.66,0s12.31,9.18,30.68-9,28-31.51,24.63-42.72S719.94,668,719.94,668Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M342.42,731.79s254.36,1.9,389-9.62a166,166,0,0,0,119.17-65.92l1.53-2.08c36.64-50.42,67.71-92.33,75-92.33s28.72,10,34,18.17S860.33,768.18,834.83,770.23s-485.37,0-485.37,0-14.8,1.18-14.36-10S333.05,731.79,342.42,731.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M915.58,571.22s-1.6,154.17-220.85,163S336.06,738,336.06,738s.89-7.79,9.88-6.2c0,0,279.57.08,326.2-5.71,0,0,89.85,2.41,134-28.85,0,0,30.49-16.07,53.33-53.17S915.58,571.22,915.58,571.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M863,569.83s2,20.93,30.18,27.47c0,0,47.56-51.29,45.8-60.86s-24.23-28.33-34.2-23.45S863,569.83,863,569.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M863,569.83s55.52-20.61,44.74-57.6C907.74,512.23,864.07,562.13,863,569.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M872,447.14s-30.88-12.31-28.14,20.13,35.94,30.87,22.27,43.77-15.24,18-15.24,18,13.49-10.35,19.15-5.47,3.52,12.9-.58,19.15-5.3,24.3-5.3,24.3,62.6-36.8,43.64-67.29S847.14,462,872,447.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M767.81,624.76l-2-4.3s34.79-19,45.92-20.52,23.06,10,18.37,21.69-43,41.2-43,41.2S778.07,658.07,767.81,624.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "671.71 474.5 682.4 469.03 697.25 527.65 686.14 529.52 671.71 474.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M767.81,624.76s-27.55,13.29-28.92,11.14S707.82,557,707.82,557s-3.91-19.74,1.56-28,7-12.89,5.47-18.17-.6-12.31.58-13.48-3.7-3.91-7.8,0,.19,18.76-6.06,19.34-12.9,3.72-22.47-12.31c0,0-2.54-.39-2.54,4.69s1,20.72,3.9,23.65c2.6,2.59,12.23,16.67,14.27,24.2,0,.43,5.46,113.65,28.87,111.75s55.83-15.1,55.83-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M437.39,546.89s11.72-15.82,25.2,4.69,30.19,71.76,19.35,79S450,615.18,440.32,580.89C440.32,580.89,434.16,558.62,437.39,546.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M848.86,647.15s-69.2,82.62-166.18,70.76l3.26,7.44S761.4,724.11,796.75,702,839.64,673.05,848.86,647.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M768.73,628s3.95,26.38-11,33.26l21.69-7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.77,405.35C75,422.87,68.65,439.74,63.59,456.94c-5.21,17.7-10.46,35.71-10.4,54.16a96.66,96.66,0,0,0,26.08,65.29c6.46,6.84,14,12.82,19,20.8s6.81,18.94,1.25,26.53c-8,10.95-25.15,8.58-36.87,15.42-14.75,8.61-16.8,30.56-8.39,45.42S100.94,742,155.59,731.44c24.46-4.72,57.62-28,56.67-52.89-1-25.92-25.73-46.91-24.89-72.84.55-17,12-31.34,21.85-45.16s19.1-30.66,14.55-47C217.07,489.42,186,482,171,462c-9.68-12.88-11.81-29.82-12.41-45.91s-.19-32.6-5.56-47.78C140,331.45,93.76,335.85,78.77,405.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 134.92,
    y: 497.97,
    width: 2.57,
    height: 279.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.47,578.69l-2.54-.41c4.16-25.28,32.9-41,34.13-41.65l1.21,2.27C170,539.05,141.42,554.68,137.47,578.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.93,688.7c-2.81-17.09-23.17-28.21-23.37-28.32l1.22-2.27c.88.47,21.68,11.85,24.69,30.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M89.69,767.69h92.58a0,0,0,0,1,0,0v26.68a31.82,31.82,0,0,1-31.82,31.82H121.51a31.82,31.82,0,0,1-31.82-31.82V767.69A0,0,0,0,1,89.69,767.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.13,823.69a33.06,33.06,0,0,1-17.72-29.33v-9.81H91v9.81a30.47,30.47,0,0,0,16.35,27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 89.69,
    y: 776.04,
    width: 92.58,
    height: 2.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 123.3,
    y: 766.4,
    width: 58.98,
    height: 2.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 137.13,
    y: 826.19,
    width: 66.38,
    height: 2.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 833.24,
    cy: 502.17,
    r: 2.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M820,528s4.15,1.44,11.3-.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.1,527.7a11.91,11.91,0,0,0,2.72.5,22.42,22.42,0,0,0,2.84,0,24.6,24.6,0,0,0,2.83-.36c.94-.17,1.87-.4,2.79-.65-.9.3-1.82.59-2.75.82a24.53,24.53,0,0,1-2.84.54,19.85,19.85,0,0,1-2.89.17,12,12,0,0,1-2.94-.36Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/animation.c50e378e5238669442c633723f5be2d0.svg";
export { ForwardRef as ReactComponent };